import { Filter } from '@cubejs-client/core';
import { BarChartOutlined } from '@mui/icons-material';
import { Widget, WidgetContent, WidgetHeader, WidgetIcon, StackedBarChart, useScrollIntoView } from '@procureai/ui-mui';
import { isEmpty, isNil } from 'ramda';

import { CircularProgressCentered } from '~/components/CircularProgressCentered/CircularProgressCentered';
import { PlaceholderWidget } from '~/components/PlaceholderWidget/PlaceholderWidget';

import { useOrderVolumeByCommodityGroup } from './OrderVolumeCommodityGroupWidget.hooks';

interface OrderVolumeCommodityGroupWidgetProps {
  config: {
    filters: Filter[];
    cube: string;
  };
}

export const OrderVolumeCommodityGroupWidget = ({ config }: OrderVolumeCommodityGroupWidgetProps) => {
  const [widgetRef, active] = useScrollIntoView({ hash: 'order-volume-commodity-group' });

  const { title, subTitle, data, dataConfig, xAxis, yAxis, isLoading } = useOrderVolumeByCommodityGroup({
    config,
  });

  const isDataEmpty = isEmpty(data) || isNil(data);

  return (
    <Widget hover="js" ref={widgetRef} active={active} data-intercom-target="OrderVolumeCommodityGroupWidget">
      <WidgetHeader
        icon={<WidgetIcon icon={<BarChartOutlined fontSize="small" />} />}
        title={title}
        subTitle={subTitle}
      />
      <WidgetContent>
        {!isDataEmpty ? (
          <StackedBarChart
            tooltip
            legend
            data={data}
            dataKey="label"
            dataConfig={dataConfig}
            xAxis={xAxis}
            yAxis={yAxis}
          />
        ) : isLoading ? (
          <CircularProgressCentered sx={{ position: 'relative' }} />
        ) : (
          <PlaceholderWidget />
        )}
      </WidgetContent>
    </Widget>
  );
};
